// routes-domain-a.ts
import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { loginGuard } from './guards/login.guard';
import { CommunityMembershipGuard } from './guards/community-membership.guard';
import { TokenAlignGuard } from './guards/token-align.guard'; 

import { LoginComponent } from './public/login/login.component';
import { ProfileComponent } from './private/profile/profile.component';
import { RegistrationComponent } from './public/registration/registration.component';
import { ForgotPasswordComponent } from './public/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './public/reset-password/reset-password.component';
import { PageNotFoundComponent } from './public/page-not-found/page-not-found.component';
import { HomeComponent } from './private/home/home.component';
import { CommunityDetailComponent } from './public/community-detail/community-detail.component';
import { CommunityUsersComponent } from './private/community-users/community-users.component';
import { JobApplicantsComponent } from './private/job-applicants/job-applicants.component';

import { SpaceResolver } from './shared/space.resolver';

export const ROUTES_DOMAIN_A: Routes = [
  // Public post preview — but we still ALIGN TOKEN if user is logged in
  {
    path: ':slug/:communityId/post/:uuid',
    canActivate: [TokenAlignGuard],                   
    loadComponent: () =>
      import('./public/public-post/public-post.component').then(m => m.PublicPostComponent),
    resolve: { space: SpaceResolver },
    runGuardsAndResolvers: 'paramsChange',
  },

  // Public community auth routes
  { path: ':slug/:communityId/login', component: LoginComponent, canActivate: [loginGuard] },
  { path: ':slug/:communityId/registration/:email', component: RegistrationComponent },
  { path: ':slug/:communityId/forgot-password', component: ForgotPasswordComponent },
  { path: ':slug/:communityId/reset-password/:email', component: ResetPasswordComponent },

  // Redirect clean base of a community to /home
  { path: ':slug/:communityId', pathMatch: 'full', redirectTo: ':slug/:communityId/home' },

  // Protected routes — run aligner THEN membership/auth
  {
    path: ':slug/:communityId/home',
    canActivate: [TokenAlignGuard, CommunityMembershipGuard, authGuard],   // ⬅️ align first
    component: HomeComponent,
    resolve: { space: SpaceResolver },
    runGuardsAndResolvers: 'paramsChange',
  },
  {
    path: ':slug/:communityId/profile',
    canActivate: [TokenAlignGuard, CommunityMembershipGuard, authGuard],   // ⬅️ align first
    component: ProfileComponent,
    resolve: { space: SpaceResolver },
    runGuardsAndResolvers: 'paramsChange',
  },
  {
    path: ':slug/:communityId/community-users',
    canActivate: [TokenAlignGuard, CommunityMembershipGuard, authGuard],   // ⬅️ align first
    component: CommunityUsersComponent,
    resolve: { space: SpaceResolver },
    runGuardsAndResolvers: 'paramsChange',
  },
  {
    path: ':slug/:communityId/:postID/applicants',
    canActivate: [TokenAlignGuard, CommunityMembershipGuard, authGuard],   // ⬅️ align first
    component: JobApplicantsComponent,
    resolve: { space: SpaceResolver },
    runGuardsAndResolvers: 'paramsChange',
  },

  // Public community landing (no communityId)
  { path: ':slug', component: CommunityDetailComponent },

  // 404
  { path: '**', component: PageNotFoundComponent },
];
